import React, { useEffect, useState } from "react";
import styled from "styled-components";

const testimonials = [
  {
    text:
      "Thankyou so much Mundra Firm for completing my LMPC and EPR work within a single day. Extremely professional and responsive team.",
    name: "Akash Chaudhary",
    role: "Business Owner",
  },
  {
    text:
      "Outstanding legal representation and corporate advisory services. One of the most reliable firms for import licenses and compliance support.",
    name: "Golu Gyan",
    role: "Entrepreneur",
  },
  {
    text:
      "Excellent support during a difficult family matter. Everything was handled with professionalism, sensitivity, and complete transparency.",
    name: "Vikash Singh",
    role: "Government Employee",
  },
  {
    text:
      "Their legal team guided us through complex GST compliance and documentation smoothly. Highly recommended for businesses.",
    name: "Rahul Verma",
    role: "Director",
  },
  {
    text:
      "Professional, responsive, and detail-oriented. The arbitration support and legal drafting exceeded expectations.",
    name: "Neha Sharma",
    role: "Corporate Client",
  },
  {
    text:
      "Very smooth experience with trademark registration and legal compliance. The team communicated clearly throughout the process.",
    name: "Aman Gupta",
    role: "Startup Founder",
  },
];

const Section = styled.section`
  padding: 8rem 0;

  background:
    radial-gradient(
      circle at top left,
      rgba(139,115,85,0.12),
      transparent 30%
    ),
    linear-gradient(
      180deg,
      #0B111E 0%,
      #111827 100%
    );

  position: relative;

  overflow: hidden;

  /* 1536px+ */
  @media (min-width: 1536px) {
    padding: 9rem 0;
  }

  /* 1280px */
  @media (max-width: 1280px) {
    padding: 7rem 0;
  }

  /* 1024px */
  @media (max-width: 1024px) {
    padding: 6rem 0;
  }

  /* 768px */
  @media (max-width: 768px) {
    padding: 5rem 0;
  }

  /* 480px */
  @media (max-width: 480px) {
    padding: 4rem 0;
  }

  /* 320px */
  @media (max-width: 320px) {
    padding: 3rem 0;
  }
`;

const Wrapper = styled.div`
  max-width: 920px;

  margin: 4rem auto 0;

  position: relative;

  min-height: 420px;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 0 1rem;

  /* 768px */
  @media (max-width: 768px) {
    min-height: 460px;
  }

  /* 480px */
  @media (max-width: 480px) {
    min-height: 520px;
  }
`;

const Card = styled.div`
  position: absolute;

  width: 100%;
  max-width: 920px;

  background:
    rgba(255,255,255,0.06);

  backdrop-filter: blur(18px);

  border:
    1px solid rgba(255,255,255,0.08);

  border-radius: 34px;

  padding: 3.5rem;

  text-align: center;

  box-shadow:
    0 20px 60px rgba(0,0,0,0.25);

  opacity:
    ${props => props.active ? 1 : 0};

  transform:
    ${props =>
      props.active
        ? "translateX(0) scale(1)"
        : "translateX(-120px) scale(0.92)"};

  transition:
    opacity 0.8s ease,
    transform 0.8s ease;

  pointer-events:
    ${props => props.active ? "auto" : "none"};

  overflow: hidden;

  &::before {
    content: "";

    position: absolute;

    width: 300px;
    height: 300px;

    background:
      radial-gradient(
        circle,
        rgba(184,155,114,0.18),
        transparent 70%
      );

    top: -150px;
    right: -100px;

    pointer-events: none;
  }

  .quote-icon {
    width: 90px;
    height: 90px;

    margin: 0 auto 2rem;

    border-radius: 50%;

    display: flex;
    align-items: center;
    justify-content: center;

    background:
      rgba(184,155,114,0.10);

    border:
      1px solid rgba(184,155,114,0.15);

    i {
      font-size: 2rem;
      color: #C6A56A;
    }
  }

  .testimonial-text {
    font-family:
      "Cormorant Garamond",
      Georgia,
      serif;

    font-size: 2rem;

    line-height: 1.6;

    color: #F8F5EE;

    font-style: italic;

    font-weight: 400;

    margin-bottom: 2.5rem;
  }

  .client-info {
    display: flex;
    align-items: center;
    justify-content: center;

    gap: 1rem;
  }

  .client-avatar {
    width: 64px;
    height: 64px;

    border-radius: 50%;

    background:
      linear-gradient(
        135deg,
        #B89B72 0%,
        #8B7355 100%
      );

    display: flex;
    align-items: center;
    justify-content: center;

    i {
      color: white;
      font-size: 1.2rem;
    }
  }

  .client-details {
    text-align: left;

    h5 {
      color: #ffffff;

      font-size: 1rem;

      margin-bottom: 0.3rem;

      font-family: "Inter", sans-serif;
    }

    span {
      color: #A1A1AA;

      font-size: 0.9rem;

      font-family: "Inter", sans-serif;
    }
  }

  /* 1280px */
  @media (max-width: 1280px) {
    padding: 3rem;

    .testimonial-text {
      font-size: 1.8rem;
    }
  }

  /* 1024px */
  @media (max-width: 1024px) {
    .testimonial-text {
      font-size: 1.6rem;
    }
  }

  /* 768px */
  @media (max-width: 768px) {
    padding: 2.5rem 2rem;

    border-radius: 28px;

    .testimonial-text {
      font-size: 1.4rem;
    }

    .quote-icon {
      width: 74px;
      height: 74px;
    }
  }

  /* 640px */
  @media (max-width: 640px) {
    .testimonial-text {
      font-size: 1.25rem;
      line-height: 1.7;
    }
  }

  /* 480px */
  @media (max-width: 480px) {
    padding: 2rem 1.4rem;

    border-radius: 24px;

    .testimonial-text {
      font-size: 1.08rem;
    }

    .client-avatar {
      width: 54px;
      height: 54px;
    }
  }

  /* 320px */
  @media (max-width: 320px) {
    padding: 1.6rem 1rem;

    .testimonial-text {
      font-size: 0.95rem;
    }
  }
`;

const Dots = styled.div`
  display: flex;

  justify-content: center;

  gap: 0.7rem;

  margin-top: 2rem;

  button {
    width: 10px;
    height: 10px;

    border-radius: 50%;

    border: none;

    background:
      rgba(255,255,255,0.2);

    cursor: pointer;

    transition: all 0.35s ease;
  }

  button.active {
    width: 34px;

    border-radius: 999px;

    background: #B89B72;
  }
`;

const TestimonialsSection = () => {

  const [activeTestimonial, setActiveTestimonial] = useState(0);

  useEffect(() => {

    const interval = setInterval(() => {

      setActiveTestimonial((prev) =>
        prev === testimonials.length - 1
          ? 0
          : prev + 1
      );

    }, 4500);

    return () => clearInterval(interval);

  }, []);

  return (

    <Section
      className="testimonials section"
      id="testimonials"
    >

      <div className="container">

        <div className="section-header center">

          <span className="section-tag">
            Client Testimonials
          </span>

          <h2 className="section-title">

            <span style={{ color: "#ffffff" }}>
              Trusted By
            </span>{" "}

            <span className="text-highlight">
              Businesses & Individuals
            </span>

          </h2>

        </div>

        <Wrapper>

          {testimonials.map((testimonial, index) => (

            <Card
              key={index}
              active={index === activeTestimonial}
            >

              <div className="quote-icon">
                <i className="fas fa-quote-left"></i>
              </div>

              <p className="testimonial-text">
                "{testimonial.text}"
              </p>

              <div className="client-info">

                <div className="client-avatar">
                  <i className="fas fa-user"></i>
                </div>

                <div className="client-details">
                  <h5>{testimonial.name}</h5>
                  <span>{testimonial.role}</span>
                </div>

              </div>

            </Card>

          ))}

        </Wrapper>

        <Dots>

          {testimonials.map((_, index) => (

            <button
              key={index}
              className={
                index === activeTestimonial
                  ? "active"
                  : ""
              }
              onClick={() =>
                setActiveTestimonial(index)
              }
            />

          ))}

        </Dots>

      </div>

    </Section>
  );
};

export default TestimonialsSection;